import type { ReactElement } from 'react';
import TrustpilotWidgetSchema from '@amplience/content-types/src/content-schemas/c-trustpilot-widget.json';
import { useCmsSlotsContext } from '../../context/cmsSlotsContext';
import type { CmsSlotsDeliveryKeys } from '../../utils/amplience';
import { HandlebarTemplate } from '../handlebarTemplate';
import { TrustpilotWidget } from '../trustpilot';

type CmsSlotProps = {
  deliveryKey: CmsSlotsDeliveryKeys;
};

const dynamicComponents = {
  [TrustpilotWidgetSchema.$id]: TrustpilotWidget,
};
const countdownRegex = /\{\{\s*countdown\b/;

export function CmsSlot({ deliveryKey }: CmsSlotProps) {
  const { getSlotComponent } = useCmsSlotsContext();
  const component = getSlotComponent(deliveryKey);

  if (!component || (!component.handlebar && !component.dynamic)) return null;

  if (component.handlebar) {
    const { input, template } = component.handlebar;
    const isCountdownComponent = input?.html && countdownRegex.test(input.html);

    return <HandlebarTemplate input={input} template={isCountdownComponent ? input.html : template} />;
  }
  if (component.dynamic) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const Component: (props: any) => ReactElement | null = dynamicComponents[component.dynamic._meta.schema];
    return Component && <Component {...component.dynamic} />;
  }

  return null;
}
